import { Navigate, Outlet } from "react-router-dom";
// import SecondarySidebarLayout from "components/wrappers/SecondarySidebarLayout";
import UpperSideBarLayout from "components/wrappers/UpperSidebarLayout";
import StaffMemberInfo from "pages/Users/details/info";
import StaffMemberCalender from "pages/Users/details/calender";
import StaffLeaveBalance from "pages/Users/details/balance";
import StaffMemberOvertime from "pages/Users/details/overtime";
import usePermissions from "hooks/usePermission";
import filterByPermissions from "utils/filterByPermissions";
import { PermissionCodename } from "constants/permission";

interface RouteType {
  path: string;
  element: JSX.Element;
  permission?: PermissionCodename;
}

export default function StaffRoutes() {
  const { hasPermissionTo } = usePermissions();
  const children: RouteType[] = [
    {
      path: "",
      element: <Navigate to="overview" />,
    },
    {
      path: "overview",
      element: <StaffMemberInfo />,
    },
    {
      path: "calendar",
      element: <StaffMemberCalender />,
    },
    {
      path: "leave balance",
      permission: "view_balance",
      element: <StaffLeaveBalance />,
    },
    {
      path: "overtime",
      permission: "view_staff_overtime",
      element: <StaffMemberOvertime />,
    },
  ];

  const filteredList = filterByPermissions(children, hasPermissionTo);

  return {
    path: "staff/:id",
    element: (
      <UpperSideBarLayout list={filteredList} title="">
        <Outlet />
      </UpperSideBarLayout>
    ),
    children,
  };
}